import React from "react";

const Twitter = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_158_139)">
        <path
          d="M11.7937 8.03332L18.8023 0.0619507H17.142L11.0539 6.98197L6.19491 0.0619507H0.589264L7.9386 10.5272L0.589264 18.8854H2.2495L8.6746 11.5761L13.8071 18.8854H19.4128M2.84871 1.28697H5.3993L17.1408 17.7206H14.5896"
          fill="#123333"
        />
      </g>
      <defs>
        <clipPath id="clip0_158_139">
          <rect
            width="18.8235"
            height="18.8235"
            fill="white"
            transform="translate(0.58847 0.0621338)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Twitter;
